export const DEFAULT_LOCALE = 'ko';
export const SUPPORTED_LOCALES = ['ko', 'en', 'ja', 'ru', 'de'];
export const PREFIXED_LOCALES = SUPPORTED_LOCALES.filter(locale => locale !== DEFAULT_LOCALE);

const PREFIX_PATTERN = new RegExp(`^/(${PREFIXED_LOCALES.join('|')})(?=/|$)`);

export function getLocaleFromPath(pathname = '/') {
  return pathname.match(PREFIX_PATTERN)?.[1] || DEFAULT_LOCALE;
}

export function stripLocalePrefix(pathname = '/') {
  const stripped = pathname.replace(PREFIX_PATTERN, '');
  return stripped.startsWith('/') ? stripped : `/${stripped}`;
}

export function localizePath(path, locale = DEFAULT_LOCALE) {
  if (!path || typeof path !== 'string' || /^(?:[a-z][a-z\d+.-]*:|\/\/)/i.test(path)) {
    return path;
  }

  const url = new URL(path, 'https://locale-path.invalid');
  const logicalPath = stripLocalePrefix(url.pathname);
  const prefix = locale === DEFAULT_LOCALE ? '' : `/${locale}`;
  const localizedPath = prefix && logicalPath === '/' ? prefix : `${prefix}${logicalPath}`;
  return `${localizedPath}${url.search}${url.hash}`;
}

export function localeLocationPath(location, locale = DEFAULT_LOCALE) {
  return localizePath(
    `${location.pathname || '/'}${location.search || ''}${location.hash || ''}`,
    locale,
  );
}